import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../environments/environment.production";
import { Observable } from "rxjs";
import { ResponsePropietarioFisica } from "../pojos/responsePropietarioFisica";

@Injectable({
    providedIn: 'root'
})
export class SolicitarCertificadoForaneoFisica {

    constructor(private http: HttpClient){

    }

    private endPoint: string = `${environment.HOST}/solicitarCertificadoForaneoFisica`;


    solicitarCertificadoForaneoFisica(data:any): Observable<ResponsePropietarioFisica>{
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.post<ResponsePropietarioFisica>(this.endPoint, data, { headers });
    }
}